export type JwtClaims = Record<string, unknown> & {
  sub?: string;
  email?: string;
  exp?: number;
  "cognito:groups"?: string[] | string;
};

export function decodeJwt(jwt: string): JwtClaims | null {
  try {
    const parts = jwt.split(".");
    if (parts.length < 2) return null;
    const payload = parts[1];
    const b64 = payload.replaceAll("-", "+").replaceAll("_", "/");
    const padded = b64 + "===".slice((b64.length + 3) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    const json = new TextDecoder("utf-8").decode(bytes);
    return JSON.parse(json) as JwtClaims;
  } catch {
    return null;
  }
}
